<template>
  <v-app class="app-hklii" >
    <Header></Header>

    <v-main>
      <div class="d-flex fill-height" >
        <router-view @open-rating="dialog=true" style="width: 100%"></router-view>
      </div>
      
      <!--Bottom right corner FAB buttons-->
      <v-layout column class="fab-container d-print-none" align-center>
       <v-dialog
        v-model="dialog"
        max-width="500"
        transition="dialog-bottom-transition"
      >
        <template v-slot:activator="{ attrs }">
          
        <!--Rate us FAB-->
        <v-btn
          fab
          v-bind="attrs"
          small
          @click="dialog=true"
          color="liiblack lighten-2"
          class="mb-2"
          aria-label="rate_hklii"
        >
          <v-icon color="white">mdi-comment-text-outline</v-icon>
        </v-btn>
       
      
         <!--scroll to top FAB-->
        <v-btn
          fab  small tile
          color="footergrey lighten-2"
          @click="$vuetify.goTo(pageHeight())"
        >
        <!-- v-show="fab"-->
          <v-icon small color="navlink">mdi-arrow-collapse-down</v-icon>
        </v-btn>
        <v-spacer class="mb-1"></v-spacer>

        <!--scroll to bottom of page FAB-->
        <v-btn
          v-scroll="onScroll"
          v-show="fab"
          fab small tile
          color="footergrey lighten-2"
          @click="toTop"
        >
          <v-icon small color="navlink">mdi-arrow-collapse-up</v-icon>
        </v-btn>
        </template>

        <!--Rate us popup-->
        <v-card class="pb-4 pl-1 pr-4 popup">
          
          <v-card-title class="pr-0">
            <v-row no-gutters>
              <h3 class="text-h2 liiblack--text"> {{$t('feedback.ratetitle')}} </h3>
              <v-spacer></v-spacer>
              <v-icon @click="dialog = false" >mdi-close</v-icon>
            </v-row>
          </v-card-title>

          <v-card-text>
            <span class="darkgrey--text text--darken-2"> {{$t('feedback.rateintro')}} </span>
          </v-card-text>

          <v-card-text>
            <!--Rating: ease of navigation-->
            <v-row no-gutters class="mb-3">
              <v-col cols="5"><h5 class="wdgt-subtitle mb-0 mt-2 liiblack--text">{{$t('feedback.rate_nav')}}</h5></v-col>
              <v-col cols="7">
                <v-rating
                  v-model="rating_nav"
                  color="link"
                  background-color="link"
                  empty-icon="$ratingEmpty"
                  full-icon="$ratingFull"
                  hover
                ></v-rating>
              </v-col>
            </v-row>

            <!--Rating: interface-->
            <v-row no-gutters class="mb-3">
              <v-col cols="5"><h5 class="wdgt-subtitle mb-0 mt-2 liiblack--text">{{$t('feedback.rate_interface')}}</h5></v-col>
              <v-col cols="7">
                <v-rating
                  v-model="rating_interface"
                  color="link"
                  background-color="link"
                  empty-icon="$ratingEmpty"
                  full-icon="$ratingFull"
                  hover
                ></v-rating>
              </v-col>
            </v-row>

            <!--Rating: search-->
            <v-row no-gutters class="mb-3">
              <v-col cols="5"><h5 class="wdgt-subtitle mb-0 mt-2 liiblack--text">{{$t('feedback.rate_search')}}</h5></v-col>
              <v-col cols="7">
                <v-rating
                  v-model="rating_search"
                  color="link"
                  background-color="link "
                  empty-icon="$ratingEmpty"
                  full-icon="$ratingFull"
                  hover
                ></v-rating>
              </v-col>
            </v-row>

            <!--Rating: search-->
            <v-row no-gutters class="mb-3">
              <v-col cols="5"><h5 class="wdgt-subtitle mb-0 mt-2 liiblack--text">{{$t('feedback.rate_data')}}</h5></v-col>
              <v-col cols="7">
                <v-rating
                  v-model="rating_data"
                  color="link"
                  background-color="link"
                  empty-icon="$ratingEmpty"
                  full-icon="$ratingFull"
                  hover
                ></v-rating>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-text class="pr-3">
            <!--comment on how it compares to classic-->
            <v-textarea
                name="comment"
                filled
                :label="$i18n.t('feedback.comments')"
                auto-grow
                persistent-hint
                v-model="comments"
                color="link"
                background-color="lsidebg"
                :hint="$i18n.t('feedback.comment_hint')"
            ></v-textarea>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="darkgrey"
              text
              @click="dialog = false"
            >
              {{$t('btntxt.cancel')}}
            </v-btn>
            <v-btn
              color="primary white--text"
              class="px-4"
              @click="send_comment"
              :disabled="rating_interface == 0 && rating_nav == 0 && rating_data == 0 && rating_search == 0"
            >
              {{$t('btntxt.submit')}}
            </v-btn>
          </v-card-actions>
        </v-card>

      </v-dialog>
      </v-layout>
      
      <!--loading icon-->
      <v-overlay :value="overlay" class="d-print-none">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>

    </v-main>

    <v-footer
      id="footer"
      class="d-print-none pt-3"
      color="footergrey lighten-1"
    >

      <v-row class="d-print-none" no-gutters>
        <!--SPACER LEFT PANEL--><v-col cols="12" md="3" lg="2" :class="$vuetify.breakpoint.mdAndUp?'pt-8':'pt-4'"  class="hidden-sm-and-down"></v-col> 
        
        <v-col cols="12" md="9" lg="7" class="pa-0 d-flex justify-md-center" >
          <v-sheet max-width="850px" width="100%" class="transparent">
            <v-row no-gutters>
              <v-col cols="6" sm="3">
                <v-card flat tile color="transparent">

                  <v-card-text class="pt-1 pl-3 pb-3">
                    <h6 class="text-h6 mb-2">HKLII</h6>
                    <router-link :to="{name: 'home'}" class="footer-link navlink--text">{{ $t('btntxt.ft_home') }}</router-link>
                    <router-link :to="{name: 'about'}" class="footer-link navlink--text">{{ $t('about.page_title') }}</router-link>
                    <router-link :to="{name: 'news'}" class="footer-link navlink--text">{{ $t('btntxt.news') }}</router-link>
                    <router-link to="/about#abtcontact" class="footer-link navlink--text">{{ $t('btntxt.contactus') }}</router-link>
                  </v-card-text>
                </v-card>  
              </v-col>
            
              <v-col cols="6" sm="3">
                <v-card flat tile color="transparent" >
                  <v-card-text class="pt-1 pl-3 pb-3">
                    <h6 class="text-h6 mb-2">{{$t('btntxt.ft_support')}}</h6>
                    <router-link :to="{name: 'hklii2023'}" class="footer-link navlink--text">HKLII 2023</router-link>
                    <router-link :to="{name: 'donors'}" class="footer-link navlink--text">{{ $t('btntxt.ft_donors') }}</router-link>
                    <a href="https://eform.giving.hku.hk/zend/online_donation/hong_kong_legal_information_institute" target="_blank" class="footer-link navlink--text">{{ $t('btntxt.donate') }}</a>
                    <router-link :to="{name: 'feedback'}" class="footer-link navlink--text">{{ $t('btntxt.feedback') }}</router-link>
                  </v-card-text>
                </v-card>  
              </v-col>

              <v-col cols="6" sm="3" >
                <v-card flat tile color="transparent" >
                  <v-card-text class="pt-1 pl-3 pb-3">
                    <h6 class="text-h6 mb-2">{{$t('btntxt.ft_legal')}}</h6>
                    <router-link to="/legal#disclaimer" class="footer-link navlink--text">{{ $t('btntxt.ft_disclaimer') }}</router-link>
                    <router-link to="/legal#privacy" class="footer-link navlink--text">{{ $t('legal.privacy') }}</router-link>
                    <router-link to="/legal#usage" class="footer-link navlink--text">{{ $t('legal.usage') }}</router-link>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="6" sm="3">             
                <v-card flat tile color="transparent" >
                  <v-card-text class="pt-1 pl-3 pb-3">  
                    <h6 class="text-h6 mb-2">{{$t('btntxt.ft_link')}}</h6>
                    <router-link :to="{name: 'liis'}" class="footer-link navlink--text">{{ $t('liis.page_title') }}</router-link>
                    <a href="http://www.worldlii.org/" target="_blank" class="footer-link navlink--text">WorldLII</a>
                    <a href="http://www.falm.info/" target="_blank" class="footer-link navlink--text">FALM</a>
                  </v-card-text>
                </v-card>  
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>

      <!--Footer Donate CTA-->
      <!--SPACER RIGHT PANEL--><v-col cols="12" md="12" lg="3" class="px-7 pt-1 hidden-md-and-down">
        <v-btn 
          href="https://eform.giving.hku.hk/zend/online_donation/hong_kong_legal_information_institute" 
          target="_blank"
          color="navlink" class="white--text"  block
        >
          {{$t('btntxt.donate')}}
        </v-btn>
      </v-col><!--close SPACER RIGHT PANEL-->

    </v-row>
      
    <v-card 
      flat tile 
      width="100%" 
      class="d-print-none"
      color="transparent"
    >
      <v-card-text class="pa-0">
        <v-divider></v-divider>
          <v-row class="pt-3 pb-2" no-gutters>
            <v-col cols="12" md="6">
              <p class="footer-copyright"> 
                {{$t('home.copyright')}} ©  {{ new Date().getFullYear() }} — 
                <span :class="$vuetify.breakpoint.xsOnly? 'forced-lb pb-2':''">{{$t('home.crinfo')}}</span> 
              </p>
            </v-col>
            <v-col cols="12" md="6">
             <p :class="$vuetify.breakpoint.mdAndUp? 'footer-copyright text-right' :'footer-copyright'">  {{$t('home.lawtech')}} </p>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

    </v-footer>

  </v-app>
</template>

<script>
  import Header from '@/components/applayout/Header'
  import api from '@/scripts/api'
  export default {
    name: 'App',
    components: {
      Header,
    },
    data(){
      return {
        overlay: false,
        fab: false,
        dialog: false,
        rating_nav: 0,
        rating_interface: 0,
        rating_search: 0,
        rating_data: 0,
        comments: ''
      }
    },
    watch: {
      '$i18n.locale': function(){
        sessionStorage.locale = this.$i18n.locale
      }
    },
    methods:{
      onScroll (e) {
        if (typeof window === 'undefined') return
        const top = window.pageYOffset ||   e.target.scrollTop || 0
        this.fab = top > 20
      },
      toTop () {
        this.$vuetify.goTo(0)
      },
      async send_comment(){
        this.dialog = false
        this.overlay = true

        try {
          await this.$recaptchaLoaded()
          const token = await this.$recaptcha('login')
          
          var payload = {
            'rating_nav':this.rating_nav,
            'rating_interface':this.rating_interface,
            'rating_search':this.rating_search,
            'rating_data':this.rating_data,
            'comment': this.comments || '',
            'token': token
          }
          await api.sendComment(payload)
          window.alert("Thank for rating us!")
          this.rating_nav = 0;
          this.rating_interface = 0;
          this.rating_search = 0;
          this.rating_data = 0;
          this.comments = ''
        } catch(err){
          window.alert("Please try again later.")
        } finally {
          this.overlay = false
        }
      },
      pageHeight () {
        return document.body.scrollHeight
      },
    },
    mounted(){
      this.$i18n.locale = sessionStorage.locale || 'en'
    },
    metaInfo:{
      titleTemplate: '%s | HKLII',
    }      
  };
</script>

<style lang="scss">
  //top space under the nav bar
  .v-main{
    @media print{
      margin: 0 0px !important;
      padding: 0 0px !important;
    }
  }

  #maincon{ /*just in case content flows out of bounds*/
    z-index:2;
  }

  .appbar .v-toolbar__content {
      padding-right: 0px !important;
      border-bottom: 1px solid black;
  }

  .v-messages__message{  /*adv search hints*/
    font-size: 13.5px;
    line-height: 18px;
  }

  /****footer*****/
  #footer{ /*counter the issues caused by z-index of main being 2 because of legis*/
    z-index: 3;
    border-top: 1px solid black !important;
  }
  .forced-lb{
    display: block;
  }
  .footer{
    font-size: 11px!important;
  }
  .footer-copyright{
    font-size: 10pt !important;
    font-weight: 300;
    line-height: 14.5pt;
    letter-spacing: -0.004em !important;
    margin-bottom: 0px !important;
    padding: 0px;
    background: none;
  }

  .footer-link{
    display: block;
    font-size: 10.5pt !important;
    font-weight: 400;
    font-style: normal;
    line-height: 16pt;
    letter-spacing: -0.01em !important;
    text-decoration: none !important;
    margin-bottom: 0.66em;
  }
  .footer-link:hover{
    text-decoration: underline 1px !important; 
    text-underline-offset: 0.15em;
  }

  

  /****widgets*****/
  #rside{
    background: var(--v-rsidebg-base);
    @media (max-width: 1263px) {
        border-top: 1px solid var(--v-navlink-base);
    }
  }


  /*****Data tables*****/
  .v-data-footer {
    background: var(--v-lsidebg-base);
  }

  .v-data-footer__pagination{ /* x-x of xx text in datatable pagination*/
    color: var(--v-darkgrey-lighten1);
  }

  .v-data-table tbody tr:hover {
    background:  var(--v-lsidebg-base) !important; 
  }

  .v-data-table__mobile-row{ 
    align-items: flex-start !important;
  }

  td.v-data-table__mobile-row{ /*datatables too wide at mobile*/
    min-height: auto !important;
  }
  .mobiledt_subinfo{
    color: var(--v-darkgrey-base);
    font-size: 10pt;
  }
  .mobiledt_darker{
    color: rgb(0,0,0) ;//var(--v-liiblack-base);
  }
  .mobiledt_title{
    display:inline-block;
    line-height: 1.3 !important;
    & > br{
      display:block; 
      content:""; 
      margin-top:0.3em; 
      vertical-align:top;
    }
  }

  /*always show sort arrows*/
  .v-data-table-header__icon {
    opacity: 1 !important; 
    color: var(--v-link-lighten3) !important;
    margin-left: 3px;
  }

  .v-data-table-header th.desc .v-data-table-header__icon, 
  .v-data-table-header th.sortable.active .v-data-table-header__icon{
    color: var(--v-link-base) !important;
    background: var(--v-link-lighten4) !important;
    border-radius: 20px;
  }
  
  /*for DB toc pages */
  @media screen and (max-width: 960px){
    .dbtoc tr{ 
      cursor: pointer;
    }
  }
  @media screen and (max-width: 600px){
    .dbtoc tr{ 
      display: table;
    }
  }
  .dbtoc td > span{
      cursor: pointer;
  }
  .dbtoc td {
      padding-top: 6px !important;
      padding-bottom: 3px !important;
      vertical-align: top;
  }

  .othertoc thead{
    background:  var(--v-l_other-base) ;
  }

  .legistoc thead{
    background:  var(--v-l_legis-base) ;
  }

  .casetoc thead{
    background:  var(--v-l_case-base) ;
  }

  a.routing {
    text-decoration: none; 
    color: inherit !important;
  }

  .hklii-highlight {
    //color: blue;
    display: inline; //will mess with legis block headings
    background-color: #fff400;
  }

  /*pagination button styling*/
  .v-pagination__navigation{
    box-shadow: none !important;
    background: none !important;
  }

  .v-pagination__navigation:hover{
    border: 1px solid var(--v-link-base);
  }

  button.v-pagination__item{
    box-shadow: none !important;
    background: none !important;
  }

   button.v-pagination__item:hover{
    border: 1px solid var(--v-link-base);
  }

  /*results per page menu styling*/
  .v-overflow-btn .v-input__slot{
    border-color: var(--v-link-base) !important;
  }

  /*dropdown lists*/
  .theme--light.v-list{
    background: var(--v-lsidebg-base);
  }

  .v-list-item__content{ /*text*/
    color: var(--v-liiblack-base);
  }
  .app-hklii.v-application .primary--text{
    color: var(--v-link-base) !important;
    caret-color: var(--v-link-base) !important;
  }

  /****Skele Loader******/
  .v-skeleton-loader__divider{ //for Case
    margin: 20px 0px 30px ;
  }
  .v-skeleton-loader__table-cell{ //for SectionTOC
    height: 25px !important;
  }
  .v-skeleton-loader__heading{ //for Section
    margin-bottom: 20px;
  }
  .v-skeleton-loader__list-item-two-line, .v-skeleton-loader__list-item-three-line{ //for Section
    height:55px !important;
    padding-left: 1.5em !important;
  }


  /****Input Fields****/
  .v-autocomplete.v-select--is-menu-active .v-input__icon--append .v-icon {
    transform: none;
  }

  /****FAB****/
  .fab-container {
    position: fixed;
    bottom: 18px;
    right: 18px;
    z-index: 4;
    opacity: 0.5;
  }
  .fab-container:hover {
    opacity: 1;
    transition: 0.1s;
  }
  .popup{
    border: solid 1px var(--v-liiblack-base) !important;
    border-top: solid 4px var(--v-liiblack-base) !important;
  }
  .v-rating .v-icon{
    padding: 0.5rem 3px !important;
  }

  @import "sass/main.scss";
</style>
